<div class="bc-gray-lighter bw-1 br-3 pa-4">
    <div class="row jc-c">
        <div class="bch-tabset col-12">
            <mat-tab-group mat-align-tabs="start" class="jc-c">
                <!-- FORMATO DE CÉDULA ACTUAL -->
                <mat-tab label="Cédula Actual">
                    <div class="cedula cedula-front"></div>
                </mat-tab>
                <!-- FORMATO DE CÉDULA ANTIGUA -->
                <mat-tab label="Cédula Antigua">
                    <div class="cedula cedula-back"></div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
